// import user from './modules/user'
// import menu from './modules/menu'

const getters = {
};
// 并导出
export default getters;
